import CsvUploadController from './components/csv_upload_controller';

export default class NotificationUploadController extends CsvUploadController {

  static targets = [
    'submitButton',
  ];

  connect() {
    this.submitButtonTarget.disabled = true;
  }

  handleFileInputChange() {
    const enableButton = super.canUploadFile();

    if (enableButton) {
      // enable submit button
      if (this.hasSubmitButtonTarget) {
        this.submitButtonTarget.disabled = false;
      }
    }
  }
}
